module.exports = __webpack_public_path__ + "img/playlist_play-24px.1ef47d99.svg";